import languagesData from "@/assets/languages.json";

/**
 * Language configuration for agent communication
 */
export interface Language {
  id: string; // Language name e.g., "English", "Spanish"
  isDefault?: boolean; // Mark default language
}

/**
 * Get all available language options
 */
export const getAvailableLanguages = (): Language[] => {
  return languagesData.languages;
};

/**
 * Get the default language
 */
export const getDefaultLanguage = (): Language => {
  const defaultLanguage = languagesData.languages.find(
    (language) => language.isDefault
  );
  if (!defaultLanguage) {
    throw new Error("No default language found in configuration");
  }
  return defaultLanguage;
};
